export const thunkTypes = {
  GET_DETAIL: `deliveries/getDetail`,
};
